import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Button, Form, Input, Card } from "antd";
import { UserOutlined, MailOutlined } from "@ant-design/icons";
import axios from "axios";
import Swal from "sweetalert2";
import {
  ApartmentOutlined,
  MessageOutlined,
  SendOutlined,
} from "@mui/icons-material";

import colors from "./constants/Colors";

const { TextArea } = Input;

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + `=` + encodeURIComponent(data[key]))
    .join(`&`);
}

const Contact = () => {
  const formName = `contact2`;
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    organization: "",
    message: "",
  });
  const navigate = useNavigate();

  const project_id = localStorage.getItem("project_id");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  /* const handleSubmit = (values) => {
    if (values[`bot-field`] === undefined) {
      delete values[`bot-field`];
    }

    fetch(`/`, {
      method: `POST`,
      headers: { "Content-Type": `application/x-www-form-urlencoded` },
      body: encode({
        "form-name": formName,
        ...values,
      }),
    })
      .then(() => showSuccess())
      .catch((error) => showError(error));
  };
 */

  const handleSubmit = async () => {
    const access_token = localStorage.getItem("access_token");

    try {
      console.log("Form Data:", formData); // For debugging purposes
      const response = await axios.post(
        " https://eutracker.rdiup.com/v1/chat/send_message/",
        JSON.stringify(formData), // Send formData directly as JSON
        {
          headers: {
            "Content-Type": "application/json", // Specify the content type
          },
        }
      );
      if (response.status === 200) {
        // alert("Message sent successfully");
        Swal.fire("Message sent successfully!", "", "success");

        navigate(-1);

        // Clear form after successful submission
        setFormData({
          full_name: "",
          email: "",
          organization: "",
          message: "",
        });
      } else {
        alert("Failed to send message");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const showSuccess = () => {
    // TODO: Show a success message or navigate to a success page.
    console.log(`form submitted successfully`);
  };

  const showError = (error) => {
    // TODO: Show an error message to the user
    console.log(`There was an error submitting the form`);
    console.log(error);
  };

  return (
    <Row justify="space-around">
      <div>
        <Col xs={22} sm={18} md={16} lg={24}>
          <h1>
            Contact Us{" "}
            <MessageOutlined
              fontSize="50px"
              style={{ color: project_id ? colors.primary : "#085ca4" }}
            />
          </h1>
          <Form layout="vertical">
            <Form.Item
              label="Full name"
              rules={[
                { required: true, message: `Please enter your fullname.` },
              ]}
              name="full_name"
              style={{ fontWeight: "600", textAlign: "left" }}
            >
              <Input
                name="full_name"
                value={formData.full_name}
                onChange={handleChange}
                style={{ width: "250px" }}
                prefix={<UserOutlined className="site-form-item-icon" />}
              />
            </Form.Item>

            <Form.Item
              label="Email"
              rules={[
                {
                  required: true,
                  type: "email",
                  message: `Please enter your email.`,
                },
              ]}
              name="email"
              style={{ fontWeight: "600", textAlign: "left" }}
            >
              <Input
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={{ width: "250px" }}
                prefix={<MailOutlined className="site-form-item-icon" />}
              />
            </Form.Item>

            <div style={{ display: "flex" }}>
              <Form.Item
                style={{ marginRight: 10, fontWeight: "600" }}
                label="Organisation"
                rules={[
                  {
                    required: true,
                    message: `Please enter your organisation name.`,
                  },
                ]}
                name="organization"
              >
                <Input
                  name="organization"
                  value={formData.organization}
                  onChange={handleChange}
                  style={{ width: "250px" }}
                  prefix={<ApartmentOutlined className="site-form-item-icon" />}
                />
              </Form.Item>
              <Form.Item
                label="PIC"
                rules={[
                  {
                    required: false,
                    type: "number",
                    message: `Please enter your pic number.`,
                  },
                ]}
                name="pic"
                style={{ fontWeight: "600" }}
              >
                <Input
                  placeholder="Your pic"
                  prefix={<ApartmentOutlined className="site-form-item-icon" />}
                />
              </Form.Item>
            </div>

            <Form.Item
              label="Message"
              rules={[
                { required: true, message: `Please enter your message.` },
              ]}
              name="message"
              style={{ fontWeight: "600" }}
            >
              <Input.TextArea
                name="message"
                value={formData.message}
                placeholder="Add your message"
                onChange={handleChange}
                style={{ width: "550px" }}
                rows={4}
              />{" "}
            </Form.Item>
            <br />
            <Form.Item>
              <Button
                onClick={handleSubmit}
                type="primary"
                //htmlType="submit"
                style={{
                  width: "100%",
                  backgroundColor: project_id ? colors.primary : "#085ca4",
                }}
                disabled={false}
              >
                Send
                <SendOutlined />
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </div>
    </Row>
  );
};
export default Contact;
